module.exports = __webpack_public_path__ + "static/media/salam.df803915.png";